class EarningsExpensesUrlPath {
    public static BASE = "/earningsExpenses";

    public static GROUPED_BY_MONTH_AND_YEAR = EarningsExpensesUrlPath.BASE + "/groupedByMonthAndYear";
    public static GROUPED_BY_YEAR = EarningsExpensesUrlPath.BASE + "/groupedByYear";
}

export default EarningsExpensesUrlPath;